export const PARAM_NAME_OLD_PASSWORD = "oldPassword";
export const PARAM_NAME_NEW_PASSWORD = "newPassword";
export const PARAM_NAME_RE_ENTERED_NEW_PASSWORD = "reEnteredNewPassword";

export const FORM_KEY_OLD_PASSWORD = 'oldPassword';


// WEBPACK FOOTER //
// ./src/features/home/components/constants/ChangePasswordConstants.js